export default __webpack_public_path__ + "static/yukyung.kang-9638a79945051a7152a7647cf91dd196.jpeg";